import {
  CommentGuardIcon,
  CustomerChatIcon,
  FacebookOptinIcon,
  LandingPageIcon,
  OptInPopupIcon,
  PageWelcomerIcon,
  ShareLinkIcon,
  SmsKeywordIcon,
  InstagramCommentGuardIcon,
  InstagramWelcomerIcon,
  InstagramStoryMentionIcon,
} from '@mm/icons/StarterIcons';
import React from 'react';
import { StepProps } from '../Steps';
import '../Steps.scss';
import { StepControls } from './Controls';
import { StepHeader } from './Header';

export const FirstStep = (props: StepProps) => {
  return (
    <div className="step-container first-step">
      <StepHeader {...props} />
      <div className="step-container__title">
        Automate conversations across all your web properties and chat channels
        in three simple categories:
      </div>
      <div className="step-container__columns-container">
        <div className="step-container__column" style={{ flex: 1.2 }}>
          <div className="step-container__title">Chat Starters</div>
          <div className="step-container__description">
            All the tools you need to start more conversations on your website,
            Facebook Page and Instagram account.
          </div>
          <p className="step-container__description-paragraph">
            <CommentGuardIcon className="step-container__description-icon" />
            Facebook Comment Guard
          </p>
          <p className="step-container__description-paragraph">
            <InstagramCommentGuardIcon className="step-container__description-icon" />
            Instagram Comment Guard
          </p>
          <p className="step-container__description-paragraph">
            <InstagramStoryMentionIcon className="step-container__description-icon" />
            Instagram Story Mentions
          </p>
          <p className="step-container__description-paragraph">
            <SmsKeywordIcon className="step-container__description-icon" />
            SMS Keyword
          </p>
          <p className="step-container__description-paragraph">
            <PageWelcomerIcon className="step-container__description-icon" />
            Facebook Page DM Autoresponder
          </p>
          <p className="step-container__description-paragraph">
            <InstagramWelcomerIcon className="step-container__description-icon" />
            Instagram DM Autoresponder
          </p>
          <p className="step-container__description-paragraph">
            <CustomerChatIcon className="step-container__description-icon" />
            Customer Chat Widgets
          </p>
          <p className="step-container__description-paragraph">
            <ShareLinkIcon className="step-container__description-icon" />
            Share Links
          </p>
          <p className="step-container__description-paragraph">
            <LandingPageIcon className="step-container__description-icon" />
            Landing Pages
          </p>
          <p className="step-container__description-paragraph">
            <FacebookOptinIcon className="step-container__description-icon" />
            Facebook Opt-in
          </p>
          <p className="step-container__description-paragraph">
            <OptInPopupIcon className="step-container__description-icon" />
            Opt-in Popup
          </p>
        </div>
        <div className="step-container__column">
          <div className="step-container__title">Dialogues</div>
          <div className="step-container__description">
            Create rich, conversational experiences on Web Chat, SMS, Facebook
            Messenger and Instagram.
          </div>
          <p className="step-container__description-paragraph">
            - Create and edit dialogues
          </p>
          <p className="step-container__description-paragraph">
            - Group your dialogues as you like.
          </p>
          <p className="step-container__description-paragraph">
            - Test it and see how your clients see it.
          </p>
        </div>
        <div className="step-container__column step-container__column-qa">
          <div className="step-container__title">Q&A</div>
          <div className="step-container__description">
            Handle frequently asked questions like a boss.
            <br />
            <br />
            <br />
          </div>
          <p className="step-container__description-paragraph">
            - Responds with custom text or a dialogue that you choose
          </p>
          <p className="step-container__description-paragraph">
            - Monitors unanswered questions
          </p>
        </div>
      </div>
      <StepControls {...props} />
    </div>
  );
};
